export const TableEvaluationPatient = ({ evaluations }) => {
  return (
    <div className="accordion" id="evaluationsPatient">
      {evaluations.map((evaluation) => (
        <div className="accordion-item" key={evaluation.questionGroupId}>
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#question-group-${evaluation.questionGroupId}`}
              aria-expanded="true"
              aria-controls={`question-group-${evaluation.questionGroupId}`}
            >
              Encuesta: {evaluation.questionGroupTitle}
            </button>
          </h2>
          <div
            id={`question-group-${evaluation.questionGroupId}`}
            className="accordion-collapse collapse"
            data-bs-parent="#evaluationsPatient"
          >
            <div className="accordion-body">
              <div className="table-responsive shadow rounded">
                <table className="table table-center bg-white mb-0">
                  <thead className="table-primary">
                    <tr>
                      <th className="border-bottom p-3">#</th>
                      <th className="border-bottom p-3">Preguntas</th>
                      <th className="border-bottom p-3">Respuestas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {evaluation.questions.map((question, index) => (
                      <>
                        <tr key={question.id}>
                          <td className="py-3 fw-bold">{index + 1}.</td>
                          <td className="py-3">{question.questionTitle}</td>
                          <td className="py-3">{question.value}</td>
                        </tr>
                        {question.followUpQuestion && (
                          <tr key={question.followUpQuestion.id}>
                            <td className="py-3"></td>
                            <td className="py-3">
                              {question.followUpQuestion.question.title}
                            </td>
                            <td className="py-3">
                              {question.followUpQuestion.value}
                            </td>
                          </tr>
                        )}
                      </>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
